import { FC, useContext } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { appStoreContext } from '../../../stores/context.store';
import { LeftArrowIcon } from '../icons/left-arrow';
import { useTopBarStyles } from './topBar.styles';

export const TopBar: FC = () => {
  const classes = useTopBarStyles();
  const appStore = useContext(appStoreContext);

  const linkCN = cn(classes.link, classes.back_link);

  return (
    <div className={classes.root}>
      <hr className={classes.line} />
      <div className={classes.content}>
        <a href={appStore.config.builderWEB} className={linkCN}>
          <LeftArrowIcon />
          <span>
            Вернуться в ассесмент
          </span>
        </a>
        <Link to="/" className={classes.link_active}>
          Оценка 360
        </Link>
      </div>
    </div>
  );
};
